module.exports = __webpack_public_path__ + "static/media/Tata-logo.92d2e6e4.png";